import React, { useCallback, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import CreateIcon from "@mui/icons-material/Create";
import { Backdrop, CircularProgress, Switch } from "@mui/material";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { isEmptyDash, strToDate, trimString } from "../../constant";
import paginationFactory from "react-bootstrap-table2-paginator";

import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import checkImage from "../../assests/images/check-circle.png";
import DeleteIcon from "@mui/icons-material/Delete";
import BootstrapTable from "react-bootstrap-table-next";
import { subRouteMapping } from "../../constant/subRoutes";
import { adminServices } from "../../services/adminServices";
import { categoryServices } from "../../services/categoryServices";
import { Link, useLocation } from "react-router-dom";
import _ from "lodash";
import AlertComponent from "../alert/alert";
import ConfirmModal from "../common/confirmModal";
import * as XLSX from "xlsx";
import routes from "../../routes";
import sampleEmployeFile from "../../assests/document/bulk_employee_creation.xlsx";
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';
import { UserObj } from "../../services/localStarage";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import axios from "axios";
import { urlConstants } from "../../constant";
import { downloadFile } from "../buyerPurchaseOrder";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },

  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const createEmpTableArr1 = [
  {
    label: "Employee Id",
    name: "employeeId",
    value: "",
    options: [],
    errMsg: "",
  },
  {
    label: "Department",
    name: "employeeDepartment",
    value: "",
    options: [],
    errMsg: "",
  },
  {
    label: "Contact Name",
    name: "contactName",
    value: "",
    options: [],
    errMsg: "",
  },
  { label: "Email", name: "email", value: "", options: [], errMsg: "" },
  {
    label: "Phone  Number",
    name: "phoneNumber",
    value: "",
    options: [],
    errMsg: "",
  },
  { label: "Role", name: "employeeRole", value: "", options: [], errMsg: "" },
  { label: "DOB", name: "dateOfBirth", value: "", options: [], errMsg: "" },
];

const requestPayloadInitials = {
  pageNumber: 1,
  pageSize: 10,
  sortArray: [],
  searchCriteria: [],
};

const initialColumns = [
  { id: "userName", label: "User Name", isSort: true, sortLabel: "", isFiltered: false },
  { id: "employeeId", label: "Employee ID", isSort: true, sortLabel: "", isFiltered: false },
  { id: "contactName", label: "Contact Name", isSort: true, sortLabel: "", isFiltered: false },
  { id: "employeeDepartment", label: "Department", isSort: true, sortLabel: "", isFiltered: false },
  { id: "employeeRole", label: "Employee Role", isSort: true, sortLabel: "", isFiltered: false },
  { id: "phoneNumber", label: "Contact Number", isSort: true, sortLabel: "", isFiltered: false },
  { id: "email", label: "Email ID", isSort: true, sortLabel: "", isFiltered: false },


  // { id: "state", label: "State", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "assignee", label: "Assignee Name", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "profileEvaluation", label: "Profile Evaluation", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "factoryVisit", label: "Factory Visit", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "complianceCheck", label: "Compliance Check", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "financialEvaluation", label: "Financial Evaluation", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "finalRating", label: "Final Rating", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "finalStatus", label: "Final Status", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "onboardingType", label: "Onboarding type", isSort: true, sortLabel: "", isFiltered: false },
  { id: "action", label: "Action", isSort: false, sortLabel: "", isFiltered: false }
];

// const columns = [
//   {
//     dataField: "Checkbox",
//     text: "",
//     formatter: (cell, row) => {
//       return <input type="checkbox" id={row._id} />;
//     },
//   },

//   /*{
//     dataField: "_id",
//     text: `User ID`,
//     sort: true,
//   },*/
//   {
//     dataField: "userName",
//     text: `User Name`,
//     sort: true,
//   },
//   {
//     dataField: "employeeId",
//     text: "Employee ID",
//     sort: true,
//   },
//   {
//     dataField: "contactName",
//     text: "Contact Name",
//     events: {
//       onChange: (e, column, columnIndex, row, rowIndex) => { },
//     },
//     formatter: (cell, row, rowIndex) => {
//       return (
//         <Link to={`/admin/profile/${row.employeeUserId}`}>
//           {row.contactName}
//         </Link>
//       );
//     },
//     sort: true,
//   },
//   {
//     dataField: "employeeDepartment",
//     text: "Department",
//     sort: true,
//   },

//   {
//     dataField: "employeeRole",
//     text: "Employee Role",
//     sort: true,
//   },
//   {
//     dataField: "phoneNumber",
//     text: " Contact Number",
//     sort: true,
//   },

//   {
//     dataField: "email",
//     text: "Email ID",
//     sort: true,
//   },

//   /* {
//      dataField: "assignedGeography",
//      text: "Assigned Geography	",
//      sort: true,
//    },*/

//   {
//     dataField: "action",
//     text: "Action",
//     events: {
//       onChange: (e, column, columnIndex, row, rowIndex) => { },
//     },
//     formatter: (cell, row, rowIndex) => {
//       return (
//         <div className="d-flex">
//           <div className=""> {row?.status ? "Active" : "Deactive"} </div>
//           {/* <div className="">Active</div> */}
//           <Switch
//             className="emp-ls-active-txt"
//             checked={row?.status}
//             onChange={(e) => handleMandattoryToggle(e, cell, row, rowIndex)}
//           />
//           <div
//             className="vendor-action"
//             // onClick={(e) => openAlert(true, "success", `Coming Soon.`)}
//             onClick={(e) => setOpenVendoreditEmployee(e, cell, row, rowIndex)}
//           >
//             <CreateIcon className="edit_icon_panel" />
//           </div>

//           {/* <div className="vendor-action"> </div>
//           <div className="vendor-action"> </div> */}
//           {row?.newUser === true && userRole === 'ADMIN' && (
//             <button type="button" class="btn" fdprocessedid="cn5f6" onClick={(e) => handleReInitiateEmployee(row?._id)}>
//               <Tooltip title="Re-invite" placement="top-start" arrow>
//                 <RefreshIcon />
//               </Tooltip>
//             </button>
//           )}

//         </div>
//       );
//     },
//     // sort: true,
//   },
//   // {
//   //   dataField: "status",
//   //   text: "Status",
//   //   sort: true,
//   // },
// ];

function EmployeeCreation() {
  const [openCreateEmp, setOpenCreateEmp] = React.useState(false);
  const [openDefaulfFields, setOpenDefaulfFields] = React.useState(false);
  const [openImportInitiated, setOpenImportInitiated] = React.useState(false);

  const [openVendorcreateEmp, setOpenVendorcreateEmp] = React.useState(false);
  const [employeecreationlist, setemployeecreationlist] = React.useState({
    employees: [],
  });
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [createEmpTableArr, setCreateEmpTableArr] =
    useState(createEmpTableArr1);
  const [inputPage, setInputPage] = useState(employeecreationlist?.currentPage || 1);

  const [name, setname] = React.useState("");
  const [employeeId, setemployeeId] = React.useState("");
  const [email, setemail] = React.useState("");
  const [phoneNumber, setphoneNumber] = React.useState("");

  const [alternatePhoneNumber, setalternatePhoneNumber] = React.useState("");
  const [dateOfBirth, setdateOfBirth] = React.useState("");
  const [departmentId, setdepartmentId] = React.useState("null");
  const [roleId, setroleId] = React.useState("null");

  const [departmentslist, setdepartmentslist] = React.useState([]);
  const [roleList, setRoleList] = React.useState([]);
  const location = useLocation();
  const [fileInput, setFileInput] = useState([]);
  const [fileData, setFileData] = useState(null);
  const [changeStatusData, setChangeStatusData] = useState({});
  const [columns, setColumns] = useState(initialColumns);

  const [filterText, setFilterText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const [emailError, setEmailsError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [alternatePhoneNumberError, setAlternatePhoneNumberError] =
    useState("");
  const [dateOfBirthError, setDateOfBirthError] = useState("");
  const [openVendoreditEmp, setOpenVendoreditEmp] = React.useState(false);
  const [editEmpId, setEditEmpID] = useState("");
  const [configSubRoute, setConfigSubRoute] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const userRole = UserObj ? UserObj?.role?.name : "";
  useEffect(() => {
    getEmployeeCreation(requestPayload, filterText);
    getdepartmentlist();
  }, [requestPayload]);

  useEffect(() => {
    setConfigSubRoute(subRouteMapping(routes, "CONFIGURATION"));
  }, []);

  const closeCreateEmp = () => {
    setOpenCreateEmp(false);
    setFileInput([]);
    setFileData(null);
  };
  
    const onPaginationChange = (e, value) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = value;
      setRequestPayload(requestPayloadInit);
    }
  
    const onPageSizeChange = (e) => {
      let { value } = e.target;
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageSize = value;
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }
    const handleInputChange = (event) => {
      const value = event.target.value;
      if (value === '' || /^[0-9]+$/.test(value)) {
        setInputPage(value);
      }
    };
    const handleInputSubmit = (event) => {
      if (event.key === 'Enter') {
        const pageNumber = parseInt(inputPage, 10);
        if (pageNumber >= 1 && pageNumber <= employeecreationlist?.totalPages) {
          onPaginationChange(null, pageNumber);
        }
      }
    };
    const onDragEnd = (result) => {
      if (!result.destination) {
        return;
      }
      const reorderedColumns = Array.from(columns);
      const [removed] = reorderedColumns.splice(result.source.index, 1);
      reorderedColumns.splice(result.destination.index, 0, removed);
  
      setColumns(reorderedColumns);
    };
    const onSortChange = (index, sortBy, sortOrder) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      let columnsInit = _.cloneDeep(columns);
      let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
      requestPayloadInit.sortArray = [sortBy, newSortLael];
      requestPayloadInit.pageNumber = 1;
      columnsInit[index].sortLabel = newSortLael;
      setRequestPayload(requestPayloadInit);
      setColumns(columnsInit);
    }

  const onImport = () => {
    if (fileInput.length < 1) {
      openAlert(true, "error", `Please select valid excel file.`);
      return;
    }
    setOpenCreateEmp(false);
    setOpenDefaulfFields(true);
  };

  const openCreateEmpSelectChange = (e, ele, i) => {
    let createEmpTableArrInit = _.cloneDeep(createEmpTableArr);
    createEmpTableArrInit[i].value = e.target.value;
    setCreateEmpTableArr(createEmpTableArrInit);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    let sFilename = file.name;
    let reader = new FileReader();
    let result = {};

    reader.onload = function (e) {
      let data = e.target.result;
      data = new Uint8Array(data);
      let workbook = XLSX.read(data, { type: "array" });
      let result = {};
      workbook.SheetNames.forEach(function (sheetName) {
        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
        });
        if (roa.length) result[sheetName] = roa;
      });
      // see the result, caution: it works after reader event is done.
      setFileInput(result?.Sheet1[0]);
      setFileData(file);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDelete = () => {
    setFileInput([]);
    setFileData(null);

    document.getElementById("fileInput").value = "";
  };

  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleMandattoryToggle = (e, cell, row, rowIndex) => {
    setChangeStatusData({ row, rowIndex });
    setIsConfirmModalOpen(true);
  };
  var editData = employeecreationlist?.employees[openVendoreditEmp?.rowIndex];
  React.useEffect(() => {
    if (editData) {
      setname(editData?.contactName);
      setemployeeId(editData?.employeeId);
      setemail(editData?.email);
      setphoneNumber(editData?.phoneNumber);
      setalternatePhoneNumber(editData?.alternatePhoneNumber);
      const datePart = editData?.dateOfBirth?.split("T")[0];
      setdateOfBirth(datePart);
      onDepartmentChange({ target: { value: editData?.departmentId } });
      setdepartmentId(editData?.departmentId);
      setroleId(editData?.roleId);
      setEditEmpID(editData?._id);
    }
  }, [editData]);

  const setOpenVendoreditEmployee = (e, cell, row, rowIndex) => {
    setOpenVendoreditEmp({ rowIndex });
    setOpenVendorcreateEmp(true);
  };

  const closeConfirmModal = () => {
    setChangeStatusData({});
    setIsConfirmModalOpen(false);
  };

  const successConfirmModal = () => {
    setIsLoading(true);
    let obj = {
      isActive: !changeStatusData?.row?.status, //true,
      id: changeStatusData?.row?._id, // "65df7b687d9c1beaea023a08",
      isEmployee: true,
    };
    adminServices
      .changeUserSatus(obj)
      .then((res) => {
        if (res.data.success == true) {
          getEmployeeCreation(requestPayload, filterText);
          setChangeStatusData({});
          setIsConfirmModalOpen(false);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
    // setChangeStatusData({});
    // setIsConfirmModalOpen(false);
  };

  const onDepartmentChange = (e) => {
    let { value } = e.target;
    let departmentlistInit = _.cloneDeep(departmentslist);
    let filterData = departmentlistInit.filter((ele) => ele._id == value);
    setRoleList(filterData[0].roles);
    setroleId("");
    setdepartmentId(value);
    // if (editData) {
    //   // If there's editData available, find the role corresponding to editData's roleId
    //   const selectedRole = filterData[0].roles.find(role => role._id === editData.roleId);
    //   if (selectedRole) {
    //     setroleId(selectedRole._id); // Set the roleId to the selected role's _id
    //   }
    // }
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const { value } = e.target;
    setemail(value);
    if (!validateEmail(value)) {
      setEmailsError("Please enter a valid email address");
    } else {
      setEmailsError("");
    }
  };
  const handlePhoneNumberChange = (e) => {
    const { value } = e.target;
    setphoneNumber(value);
    if (!validatePhoneNumber(value)) {
      setPhoneNumberError("Please enter a valid 10-digit phone number");
    } else {
      setPhoneNumberError("");
    }
  };
  const handleAlternatePhoneNumberChange = (e) => {
    const { value } = e.target;
    setalternatePhoneNumber(value);
    if (!validateAlternatePhoneNumber(value)) {
      setAlternatePhoneNumberError(
        "Please enter a valid 10-digit alternate number"
      );
    } else {
      setAlternatePhoneNumberError("");
    }
  };

  const validateAlternatePhoneNumber = (phoneNumber) => {
    const regex = /^[0-9]{10}$/;
    return regex.test(phoneNumber);
  };

  const validatePhoneNumber = (phoneNumber) => {
    const regex = /^[0-9]{10}$/;
    return regex.test(phoneNumber);
  };

  const handleDateOfBirthChange = (e) => {
    const { value } = e.target;
    setdateOfBirth(value);

    if (!validateDateOfBirth(value)) {
      setDateOfBirthError("Please enter a valid date of birth");
    } else {
      setDateOfBirthError("");
    }
  };

  const validateDateOfBirth = (date) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    return regex.test(date);
  };

  const isDeleteDisabled = !fileInput;

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, filters, data }
  ) => {
    if (type === "pagination") {
      setRequestPayload({
        ...requestPayload,
        pageNumber: page,
        pageSize: sizePerPage,
      });
    }
    if (type == "sort") {
      setRequestPayload({
        ...requestPayload,
        sortArray: [sortField, sortOrder],
      });
      // const requestPayload = {
      //   ...this.state.requestPayload,
      //   sortArray: [sortField + "," + sortOrder],
      // };
      // this.getRoleWiseSOList(requestPayload);
      // this.props.getSalesOrderList(requestPayload);
      // this.setState({
      //   sorting: true,
      // })
    }
    if (type == "filter") {
      // const requestPayload = { ...this.state.requestPayload };
      // let secondSearchCriteriaArr = [];
      // // let secondSearchCriteriaArr = Object.keys(filters).map((ele) => {
      // //   let obj = {
      // //     key: ele,
      // //     value: filters[ele].filterVal,
      // //     operation: filters[ele].comparator,
      // //   };
      // //   return obj;
      // // });
    }
  };

  const getEmployeeCreation = (requestPayloadParam, filterTextParam) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    adminServices
      .getEmployeeCreation(param)
      .then((res) => {
        if (res.data.success == true) {
          setemployeecreationlist(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });

    // requestPayload.searchCriteria = [...this.state.initialSearchCriteriaArr];
    // let param = `employeeUserId=${userObj?.userId}&pageNumber=${requestPayload?.pageNumber}&pageSize=${requestPayload?.pageSize}`;
    // for (let i = 0; i < requestPayload.searchCriteria.length; i++) {
    //   param += `&${requestPayload.searchCriteria[i].key}=${requestPayload.searchCriteria[i].value}`;
    // }

    // if (param?.salesOrderIdSearch == "" && param?.externalReferenceIdSearch == "" && param?.orderCategorySearch == "" && param?.orderSourceSearch == "" && param?.buyerFirmNameSearch == "" && param?.poIdSearch == "" && param?.totalValueSearch == "" && param?.orderDateTimeSearch == "" && param?.invoiceStatusSearch == "" ) {
    //   param.filter = 'no';
    // } else {
    //   param.filter = 'yes';
    // }
  };
  const onFilterTextChange = (e) => {
    setFilterText(e.target.value);
    debouncedSearch(e.target.value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  
  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }, 800),
    []
  );

  const onFilterSubmit = () => {
    getEmployeeCreation(requestPayload, filterText);
  };

  const getdepartmentlist = () => {
    setIsLoading(true);
    categoryServices
      .getdepartments()
      .then((res) => {
        if (res.data.success == true) {
          setdepartmentslist(res.data.data);
        } else {
          openAlert(true, "error", `No Data Found`);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });

    // requestPayload.searchCriteria = [...this.state.initialSearchCriteriaArr];
    // let param = `employeeUserId=${userObj?.userId}&pageNumber=${requestPayload?.pageNumber}&pageSize=${requestPayload?.pageSize}`;
    // for (let i = 0; i < requestPayload.searchCriteria.length; i++) {
    //   param += `&${requestPayload.searchCriteria[i].key}=${requestPayload.searchCriteria[i].value}`;
    // }

    // if (param?.salesOrderIdSearch == "" && param?.externalReferenceIdSearch == "" && param?.orderCategorySearch == "" && param?.orderSourceSearch == "" && param?.buyerFirmNameSearch == "" && param?.poIdSearch == "" && param?.totalValueSearch == "" && param?.orderDateTimeSearch == "" && param?.invoiceStatusSearch == "" ) {
    //   param.filter = 'no';
    // } else {
    //   param.filter = 'yes';
    // }
  };

  const employeeCreationBulk = () => {
    // setOpenDefaulfFields(false);
    // setOpenImportInitiated(true);
    let isValid = true;
    for (let i = 0; i < createEmpTableArr.length; i++) {
      if (isEmptyDash(createEmpTableArr[i].value)) {
        if (createEmpTableArr[i].name === 'dateOfBirth') {
          createEmpTableArr[i].errMsg = '';
        } else {
          createEmpTableArr[i].errMsg = `Please fill this required field.`;
          isValid = false;
        }
      } else {
        createEmpTableArr[i].errMsg = ``;
      }
    }
    if (isValid) {
      let dataArr = [];
      for (let i = 0; i < createEmpTableArr.length; i++) {
        let obj = {
          excelColumn: createEmpTableArr[i].value,
          field: createEmpTableArr[i].name,
        };
        dataArr.push(obj);
      }
      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("columnMappings", JSON.stringify(dataArr));

      setIsLoading(true);
      adminServices
        .createEmployeeBulk(formData)
        .then((res) => {
          // getEmployeeCreation(requestPayloadInitials, "");
          // setFileInput([]);
          window.location.reload();
          setOpenDefaulfFields(false);
          openAlert(true, "success", res?.data?.message);
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message}`);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    } else {
      setCreateEmpTableArr(createEmpTableArr);
      openAlert(true, "error", `Please fill all mandatory fields.`);
    }
  };

  const employeecreation = () => {
    let isValidData = true;
    let data = {
      name: name,
      employeeId: employeeId,
      email: email,
      phoneNumber: phoneNumber,
      // alternatePhoneNumber: alternatePhoneNumber,
      // dateOfBirth: dateOfBirth,
      departmentId: departmentId,
      roleId: roleId,
    };
    if (dateOfBirth !== "") {
      data.dateOfBirth = dateOfBirth;
    }
    if (alternatePhoneNumber !== "") {
      data.alternatePhoneNumber = alternatePhoneNumber;
    }
    // data.dateOfBirth = data.dateOfBirth.split('-').reverse().join('-');
    setIsLoading(true);

    if (
      openVendoreditEmp?.rowIndex !== "" &&
      openVendoreditEmp?.rowIndex !== undefined
    ) {
      adminServices
        .updateEmployee(data, editEmpId)
        .then((res) => {
          getEmployeeCreation(requestPayloadInitials, "");
          openAlert(true, "success", `Employee Updated successfully`);
          setname('');
          setemployeeId('');
          setemail('');
          setphoneNumber('');
          setalternatePhoneNumber('');
          setdateOfBirth('');
          setdepartmentId('');
          setroleId('');
          setOpenVendorcreateEmp(false);
          //window.location.reload();
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message}`);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    } else {
      for (let ele in data) {
        if (ele === "alternatePhoneNumber" || ele === "dateOfBirth") {
          continue;
        }
        // if (ele === "dateOfBirth" || ele === "alternatePhoneNumber") {
        //   if (data[ele] !== '' && isEmptyDash(data[ele])) {
        //     isValidData = false;
        //   }
        // } else {
        //   if (isEmptyDash(data[ele])) {
        //     isValidData = false;
        //   }
        // }
        if (isEmptyDash(data[ele])) {
          isValidData = false;
        }
      }
      if (!isValidData) {
        openAlert(true, "error", `Please fill all mandatory field`);
        return;
      }
      adminServices
        .createEmployee(data)
        .then((res) => {
          getEmployeeCreation(requestPayloadInitials, "");
          openAlert(true, "success", `Employee created successfully`);
          setname('');
          setemployeeId('');
          setemail('');
          setphoneNumber('');
          setalternatePhoneNumber('');
          setdateOfBirth('');
          setdepartmentId('');
          setroleId('');
          setOpenVendorcreateEmp(false);
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message}`);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    }
  };
  const handleReInitiateEmployee = (empId) => {
    setIsLoading(true);
    let bodydata = {};
    bodydata = {
      "employeeId": empId,
    }
    adminServices.reIinviteEmployee(bodydata)
      .then((res) => {
        if (res.data.success === true) {
          setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
        } else {
          setAlertComponent({ open: true, type: "error", message: `Something Went Wrong` });
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const handleCloseModal = () => {
    setOpenVendorcreateEmp(false);
    setname("");
    setemployeeId("");
    setemail("");
    setphoneNumber("");
    setalternatePhoneNumber("");
    setdateOfBirth("");
    setdepartmentId("");
    setroleId("");
    setEditEmpID("");
    setOpenVendoreditEmp("");
  };

  const getCurrentDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();

    if (mm < 10) {
      mm = "0" + mm;
    }
    if (dd < 10) {
      dd = "0" + dd;
    }

    return yyyy + "-" + mm + "-" + dd;
  };

  const handleDownload = () => {
    if (sampleEmployeFile) {
      const link = document.createElement('a');
      link.href = sampleEmployeFile;
      link.download = 'Sample-file';
      link.click();
    }
  };

  const DownloadExcelReport = () => {
    setIsLoading(true);
    setIsDownloading(true);
    
        const data = {
          url: `/v1/admin/employees/download`,
          bodyData: {},
          method: "POST",
          fileName: 'Employee-list.xlsx'
        };
        downloadFile(data)
          .then(response => {
            // setOpenPoPdfPurchaseSuccessModal(true);
          })
          .catch(error => {
            setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
          })
          .finally(() => {
            setIsLoading(false);
            setIsDownloading(false);
          })

    // axios({
    //   method: 'POST',
    //   url: `${urlConstants.BASE_URI_DEV}/v1/admin/employees/download`,
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Bearer ${UserObj?.accessToken}`
    //   },
    //   // data: JSON.stringify({ rfqId: rfqId }),
    //   responseType: 'blob'
    // })
    //   .then((res) => {
    //     if (res && res.data) {
    //       const url = window.URL.createObjectURL(new Blob([res.data]));
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.setAttribute('download', 'Employee-list.xls');
    //       document.body.appendChild(link);
    //       link.click();
    //       document.body.removeChild(link);
    //     } else {
    //       setAlertComponent({
    //         open: true,
    //         type: 'error',
    //         message: 'No Data Found',
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     setAlertComponent({
    //       open: true,
    //       type: 'error',
    //       message: `${error?.response?.data?.message}`,
    //     });
    //   })
    //   .finally(() => {
    //     setIsLoading(false);
    //     setIsDownloading(false);
    //   });
  }
  return (
    <div className="login-forms">
      <div className="text-centers">
        <div class="heading_search_outer d sub-route-upper-sec">
          <div className="sub-route-sec">
            {configSubRoute.map(
              (ele, i) =>
                ele.isSubRoute && (
                  <div
                    style={{ padding: "5px 7px 7px" }}
                    className={
                      location.pathname.indexOf(ele.path) !== -1
                        ? "sub-route-sec-div sub-route-sec-div-active"
                        : "sub-route-sec-div"
                    }
                  >
                    <Link to={ele.layout + ele.path}>{ele.name}</Link>
                    {/* <p>Existing Vendor</p> */}
                  </div>
                )
            )}
          </div>
        </div>
        <div className="search-filter-secs">
          <div className="search_filter_outer ">
            <div className="search_main">
              <div id="custom-search-input">
                <div className="input-group col-md-12">
                  <input
                    type="text"
                    className="form-control input-lg"
                    placeholder="Search here"
                    // fdprocessedid="7yu8sn"
                    onChange={onFilterTextChange}
                    value={filterText}
                    onKeyPress={onKeyPressHandler}
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-info btn-lg"
                      type="button"
                      fdprocessedid="t3z7qr"
                    >
                      <span className="glyphicon glyphicon-search">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                        </svg>
                      </span>
                    </button>
                  </span>
                </div>
              </div>
            </div>

            {/* <div className="filter_main">
              <button fdprocessedid="k9ovc8">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-funnel"
                    viewBox="0 0 16 16"
                  >
                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z"></path>
                  </svg>
                </span>
                Filter
              </button>
            </div> */}
          </div>
          <div className="vendor_btns emp-creation-sec">
            <button class="btn btn-success btn_rating_respo" onClick={DownloadExcelReport} disabled={isDownloading}>
              <FileDownloadIcon />
              {isDownloading ? 'Downloading...' : 'EXPORT'}</button>
            <Button
              className="vendor_btn  "
              variant="contained"
              onClick={() => setOpenVendorcreateEmp(true)}
            >
              + Create Employee
            </Button>
            <Button
              className="vendor_btn"
              variant="contained"
              color="success"
              onClick={() => setOpenCreateEmp(true)}
            >
              Import
            </Button>
          </div>
        </div>
        
        <div className="react-bootstrap-table-vendors">
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable" direction="horizontal">
                {(provided) => (
                  <div style={{ width: "100%", overflow: "hidden" }}
                    className="listing_main listing_main_dragdropcontext_body listingmain"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    <table className="dragdropcontext_ondragend_block_row">
                      <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                        <tr>
                          <th className="vendor_tabels">
                            <input type="checkbox" />
                          </th>
                          {columns.map((column, index) => (
                            <Draggable
                              key={column.id}
                              draggableId={column.id}
                              index={index}
                            >
                              {(provided) => (
                                <th
                                  className={`vendor_tabels ${column.isFiltered ? 'highlighted_column' : ''}`}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  {column.label}
                                  {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                    {/* <SwapVertIcon className="swap-sort-ico" /> */}
                                    {(column.sortLabel != "asc") && <img src={topArrow} />}
                                    {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                    {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                    {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                  </span>}
                                </th>
                              )}
                            </Draggable>
                          ))}
                        </tr>
                      </thead>
                      <tbody style={{ overflowY: "scroll", width: "200px" }}>
                        {employeecreationlist?.employees.length < 1 && <>
                          <tr>
                            <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                          </tr>
                        </>}
                        {employeecreationlist?.employees.length > 0 && <>
                          {employeecreationlist?.employees?.map((row, rowIndex) => (
                            <tr key={rowIndex} className="maine_tr_vendor">
                              <td>
                                <input type="checkbox" id={row._id} />
                              </td>
                              {columns.map((column, index) => (
                                <td key={index}>
                                  {column.id === "vendorName" ? (
                                    <Link to={`/admin/vendor-list-details/${row._id}`}>
                                    <Tooltip title={row[column.id] || "N/A"}>
                            {trimString(row[column.id], 8 || "N/A")}
                            </Tooltip>
                                    </Link>
                                  ) : (column.id === "registrationDate") ? (
                                    <span
                                      className="solutions_block_body"
                                      style={{ textDecoration: "none" }}
                                    >
                                      {isEmptyDash(row.registrationDate)
                                        ? "-"
                                        : strToDate(row[column.id])}
                                    </span>
                                  ) : (column.id === "action") ? (
                                    <div className="d-flex">
                                        <div className=""> {row?.status ? "Active" : "Deactive"} </div>
                                        {/* <div className="">Active</div> */}
                                        <Switch
                                          className="emp-ls-active-txt"
                                          checked={row?.status}
                                          onChange={(e) => handleMandattoryToggle(e, "cell", row, rowIndex)}
                                        />
                                        <div
                                          className="vendor-action"
                                          onClick={(e) => setOpenVendoreditEmployee(e, "cell", row, rowIndex)}
                                        >
                                          <CreateIcon className="edit_icon_panel" />
                                        </div>

                                        {/* <div className="vendor-action"> </div>
                                        <div className="vendor-action"> </div> */}
                                        {row?.newUser === true && userRole === 'ADMIN' && (
                                          <button type="button" class="btn" fdprocessedid="cn5f6" 
                                          onClick={(e) => handleReInitiateEmployee(row?._id)}
                                          >
                                            <Tooltip title="Re-invite" placement="top-start" arrow>
                                              <RefreshIcon />
                                            </Tooltip>
                                          </button>
                                        )}

                                      </div>
                                  ) : (
                                    <Tooltip title={row[column.id] || "N/A"}>
                            {trimString(row[column.id], 10 || "N/A")}
                            </Tooltip>
                                  )}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </>}

                      </tbody>
                    </table>
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            {employeecreationlist?.employees.length > 0 && <>
              <div className="lets_pagination_package_listing_react">
                <div className="pagination_select_react_packagelr_detail">
                  <select
                    className="form-select packagelrlisting from-hs"
                    onChange={onPageSizeChange}
                    value={requestPayload?.pageSize}
                  >
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                  <span className="react_text_showing">
                    {` Showing rows ${Number(employeecreationlist?.pageSize) * Number(employeecreationlist?.currentPage - 1) + 1} to ${Number(employeecreationlist?.pageSize) * Number(employeecreationlist?.currentPage - 1) + Number(employeecreationlist?.employees.length)} of ${employeecreationlist?.totalItems} `}
                  </span>
                </div>

                <Stack spacing={2}>
                  <Pagination
                    count={employeecreationlist?.totalPages}
                    page={employeecreationlist?.currentPage}
                    onChange={(event, page) => {
                      setInputPage(page);
                      onPaginationChange(event, page);
                    }}
                    renderItem={(item) => {
                      if (item.page === employeecreationlist?.currentPage) {
                        return (
                          <input
                            className="form-control form-hasw"
                            type="text"
                            value={inputPage}
                            onChange={handleInputChange}
                            onKeyDown={handleInputSubmit}
                            style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                          />
                        );
                      }
                      return (
                        <PaginationItem
                          className="pagination_react_listings"
                          slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                          {...item}
                        />
                      );
                    }}
                  />
                </Stack>
              </div>
            </>}
          </div>

        <div className="react-bootstrap-table-vendors">
          {/* <BootstrapTable
            remote={{ search: true, pagination: true, sort: true }}
            bootstrap4
            keyField="id"
            data={employeecreationlist?.employees}
            columns={columns}
            sort={true}
            onTableChange={handleTableChange}
            noDataIndication={"No Data Found"}
            pagination={paginationFactory({
              page:
                requestPayload.pageNumber == 0 ? 1 : requestPayload.pageNumber,
              sizePerPage: requestPayload.pageSize,
              totalSize: employeecreationlist?.totalItems,
              showTotal: true,
              pageStartIndex: 1,
              paginationSize: 2,
            })}
          /> */}

          {/* <BootstrapTable
                    remote={{ search: true, pagination: true, sort: true }}
                    bootstrap4
                    keyField="id"
                    data={this.state.salesListData}
                    columns={columns}
                    filter={filterFactory()}
                    onTableChange={this.handleTableChange}
                    noDataIndication={this.state.noDataIndication}
                    // pagination={
                    //   this.state.salesListData.length > 0
                    //     ? paginationFactory({
                    //         page:
                    //           this.state.requestPayload.pageNumber == 0
                    //             ? 1
                    //             : this.state.requestPayload.pageNumber,
                    //         sizePerPage: this.state.requestPayload.pageSize,
                    //         totalSize: this.props.salesOrderList.totalElements,
                    //         showTotal: true,
                    //         pageStartIndex: 1,
                    //         paginationSize: 10,
                    //       })
                    //     : null
                    // }
                    pagination={paginationFactory({
                      page:
                        this.state.requestPayload.pageNumber == 0
                          ? 1
                          : this.state.requestPayload.pageNumber,
                      sizePerPage: this.state.requestPayload.pageSize,
                      totalSize: this.props.salesOrderList?.totalElements,
                      showTotal: true,
                      pageStartIndex: 1,
                      paginationSize: 2,
                    })}
                  /> */}
        </div>
        {/* First Import Modal Create Employee */}
        <Modal
          open={openCreateEmp}
          onClose={closeCreateEmp}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="modal_react_controlpanel_employee">
            <div className="modal-header">
              <h5 className="modal-titles" id="uploadexcelfileLabel">
                Create Employee (Upload Excel File)
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeCreateEmp}
              ></button>
            </div>
            <div className="modal-body lets_modal_body_block_listing">
              <div id="vendorForm">
                <div className="lets_modal_vendor2">
                  <p>Upload Excel Template</p>
                  <div className="master_panel_icon_react">
                    <input
                      className="form-control form-h choose"
                      type="file"
                      id="fileInput"
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                    />
                    <DeleteIcon
                      className={`delete_icon_btn_panel_react ${isDeleteDisabled ? "disabled" : ""
                        }`}
                      style={{ color: isDeleteDisabled ? "grey" : "red" }}
                      onClick={handleDelete}
                      disabled={isDeleteDisabled}
                    />
                  </div>
                  <span onClick={handleDownload} style={{ cursor: 'pointer', fontWeight: '600' }}>Download sample file</span>
                  <div className="clear_btn_status">
                    <button
                      type="button"
                      className=" btn btn-warning"
                      data-dismiss="modal"
                      fdprocessedid="3pe65"
                      onClick={closeCreateEmp}
                    >
                      Close
                    </button>
                    <button
                      // style={{ color: isDeleteDisabled ? "grey" : "red" }}
                      // disabled={isDeleteDisabled}
                      type="button"
                      className="btn btn-success"
                      fdprocessedid="sqi0b"
                      onClick={onImport}
                    >
                      Import
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        {/* Table Modal Create Employee */}
        <Modal
          open={openDefaulfFields}
          onClose={() => setOpenDefaulfFields(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="modal_react_controlpanel_employee">
            <div className="modal-header">
              <h5 className="modal-titles" id="uploadexcelfileLabel">
                Create Employee
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setOpenDefaulfFields(false)}
              ></button>
            </div>
            <div className="modal-body">
              <p className="field_ptag_body">Defaulf Fields</p>
              <div className="vendor_configuration_list_block">
                <table className="table" id="employeeTable">
                  <thead>
                    <tr>
                      <th className="vendor_tabels">LIST OF FIELDS</th>
                      <th className="vendor_tabels">COLUMNS IN XLS FILE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {createEmpTableArr.map((ele, i) => (
                      <>
                        <tr>
                          <td>{ele?.label}</td>
                          <td>
                            <select
                              className="form-select employeecreation"
                              name="role[]"
                              value={ele?.value}
                              onChange={(e) =>
                                openCreateEmpSelectChange(e, ele, i)
                              }
                            >
                              <option value="" disabled={true}>
                                Please Select
                              </option>
                              {fileInput.map((optionData, j) => (
                                <>
                                  <option value={optionData}>
                                    {optionData}
                                  </option>
                                </>
                              ))}
                            </select>
                            <span id="businessNameError" className="error">
                              {ele?.errMsg}
                            </span>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
                <div className="clear_btn_status">
                  <button
                    type="button"
                    className="clear_btn_status_block_list_btnclose"
                    onClick={() => setOpenDefaulfFields(false)}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-success save_next_btn"
                    onClick={employeeCreationBulk}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
        {/* Successfully Modal Create Employee */}
        <Modal
          open={openImportInitiated}
          onClose={() => setOpenImportInitiated(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="modal_react_controlpanel_employee">
            <div className="modal-header">
              <h5 className="modal-titles" id="uploadexcelfileLabel">
                Create Employee
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setOpenImportInitiated(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="body_check_images_panel">
                <img src={checkImage} alt="" />
                <p>Import Initiated</p>
                <button type="button" className="btn btn-success ">
                  Done
                </button>
              </div>
            </div>
          </Box>
        </Modal>
        {/* Modal Create Employee */}

        <Modal
          open={openVendorcreateEmp}
          // onClose={() => setOpenVendorcreateEmp(false)}
          onClose={() => handleCloseModal()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={style}
            className="modal_react_controlpanel_creation_vendorlist"
          >
            <div className="modal-header">
              <h5 className="modal-titles" id="uploadexcelfileLabel">
                {editData ? "Edit Employee" : "Create Employee"}
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                // onClick={() => setOpenVendorcreateEmp(false)}
                onClick={() => handleCloseModal()}
              ></button>
            </div>
            <div className="modal-body">
              <form id="vendorForm">
                <div className="lets_modal_vendor">
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Employee Name
                      <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="contactName"
                      className="form-control form_h_modal"
                      placeholder="Enter Employee Name"
                      required=""
                      value={name}
                      onChange={(e) => {
                        setname(e.target.value);
                      }}
                    />
                    <div className="error-message" id="contactNameError"></div>
                  </div>
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Email ID <span className="required">*</span>
                    </label>
                    <input
                      type="email"
                      id="vendorEmail"
                      className="form-control form_h_modal"
                      placeholder="Enter Email ID"
                      required=""
                      value={email}
                      disabled={editData?.email ? "disabled" : ""}
                      onChange={handleEmailChange}
                    />
                    {emailError && (
                      <div className="error-message" id="vendorEmailError">
                        {emailError}
                      </div>
                    )}
                  </div>
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Phone Number <span className="required">*</span>
                    </label>
                    <input
                      type="tel"
                      id="contactNumber"
                      minLength="10"
                      maxLength="10"
                      className="form-control form_h_modal"
                      placeholder="Enter Phone Number"
                      pattern="[0-9]{10}"
                      title="Please enter a valid 10-digit mobile number"
                      required=""
                      value={phoneNumber}
                      disabled={editData?.phoneNumber ? "disabled" : ""}
                      onChange={handlePhoneNumberChange}
                    />
                    {phoneNumberError && (
                      <div className="error-message" id="contactNumberError">
                        {phoneNumberError}
                      </div>
                    )}
                  </div>
                </div>
                <div className="lets_modal_vendor">
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Alternate Mobile Number
                    </label>
                    <input
                      type="tel"
                      id="alternateContactNumber"
                      minLength="10"
                      maxLength="10"
                      className="form-control form_h_modal"
                      placeholder="Enter Alternate Phone Number"
                      pattern="[0-9]{10}"
                      title="Please enter a valid 10-digit mobile number"
                      required=""
                      value={alternatePhoneNumber}
                      onChange={handleAlternatePhoneNumberChange}
                    />
                    {alternatePhoneNumberError && (
                      <div
                        className="error-message"
                        id="alternateContactNumberError"
                      >
                        {alternatePhoneNumberError}
                      </div>
                    )}
                  </div>
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">Date of Birth</label>
                    <input
                      id="dateOfBirth"
                      className="form-control form_h_modal"
                      placeholder="Enter the Date of Birth"
                      required=""
                      value={dateOfBirth}
                      onChange={handleDateOfBirthChange}
                      type="date"
                      max={getCurrentDate()}
                    />
                    {dateOfBirthError && (
                      <div className="error-message" id="dateOfBirthError">
                        {dateOfBirthError}
                      </div>
                    )}
                  </div>
                  <div className="lets_select_sme">
                    <label className="mb-1 text-dark">
                      Employee ID
                      <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="contactName"
                      className="form-control form_h_modal"
                      placeholder="Enter Employee ID"
                      required=""
                      value={employeeId}
                      onChange={(e) => {
                        setemployeeId(e.target.value);
                      }}
                    />
                    <div className="error-message" id="contactNameError"></div>
                  </div>
                </div>
                <div className="lets_modal_vendor">
                  <div className="lets_select_sme1">
                    <label className="mb-1 text-dark">
                      Department <span className="required">*</span>
                    </label>

                    <select
                      id="onboardingType"
                      className="form-select employeecreations_panel "
                      aria-label="Default select example"
                      value={departmentId}
                      onChange={onDepartmentChange}
                    >
                      <option value={"null"}>Please Select</option>
                      {departmentslist?.map((dept) => (
                        <option value={dept?._id}>
                          {dept?.departmentName}
                        </option>
                      ))}
                    </select>
                    <div className="error-message" id="vendorEmailError"></div>
                  </div>
                  <div className="Newvendor_category">
                    <label className="mb-1 text-dark">
                      Role <span className="required">*</span>
                    </label>

                    <select
                      id="onboardingType"
                      className="form-select employeecreations_panele_list"
                      aria-label="Default select example"
                      value={roleId}
                      onChange={(e) => {
                        setroleId(e.target.value);
                      }}
                    >
                      <option value={"null"}>Please Select</option>
                      {roleList?.map((ele) => (
                        <option value={ele?._id}>{ele?.name}</option>
                      ))}
                    </select>
                    <div
                      className="error-message"
                      id="onboardingTypeError"
                    ></div>
                  </div>
                </div>

                <div className="clear_btn_status">
                  <button
                    type="button"
                    className="btn clear_btn"
                    data-dismiss="modal"
                    onClick={() => handleCloseModal()}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-success save_next_btn"
                    onClick={() => {
                      employeecreation();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </Box>
        </Modal>

        <ConfirmModal
          isConfirmModalOpen={isConfirmModalOpen}
          closeConfirmModal={closeConfirmModal}
          successConfirmModal={successConfirmModal}
          modalMsg="Do you really want to change it?"
        />

        <AlertComponent
          alertComponent={alertComponent}
          handleClose={handleClose}
        />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
}

export default EmployeeCreation;
